// src/components/pdf-reader/ZoomControls.jsx

import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export default function ZoomControls({ zoomLevel, onZoomIn, onZoomOut, onReset }) {
  return (
    <Box className="zoom-controls" data-zoom-controls>
      <Button onClick={onZoomOut}>➖</Button>
      <Typography>{Math.round(zoomLevel * 100)}%</Typography>
      <Button onClick={onZoomIn}>➕</Button>
      <Button onClick={onReset || (() => {})}>Reset</Button>
    </Box>
  );
}
